/**
 * useSelectionState - Pure State Management
 *
 * Single responsibility: Managing selection state only.
 * No business logic, no side effects, just state management.
 */

import { useState } from 'react';

/**
 * Shape of the selection state
 */
export interface SelectionState {
  teams: Record<string, string>;
  props: Record<string, 'yes' | 'no'>;
  overUnder: Record<string, 'over' | 'under'>;
  tieBreaker: string;
}

/**
 * Initial empty state
 */
const initialState: SelectionState = {
  teams: {},
  props: {},
  overUnder: {},
  tieBreaker: '',
};

/**
 * Hook that manages selection state
 *
 * @returns State and setState function
 */
export function useSelectionState() {
  const [selections, setSelections] = useState<SelectionState>(initialState);

  return {
    selections,
    setSelections,
  };
}
